/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { memo, type MemoExoticComponent } from 'react';

import { css, jsx } from '@compiled/react';
import { type SortDirection } from '@tanstack/react-table';

import ArrowDownIcon from '@atlaskit/icon/core/arrow-down';
import ArrowUpIcon from '@atlaskit/icon/core/arrow-up';
import { token } from '@atlaskit/tokens';

const styles = css({
	display: 'flex',
	alignSelf: 'center',
	opacity: 1,
	transition: 'opacity 100ms ease-in-out',
});
const SortableIconClassName = 'sortable-icon';

/**
 * __SortIcon__
 *
 * SortIcon is used to display the sort state in our SortableColumn.
 */
export const SortIcon: MemoExoticComponent<
	({
		sortDirection,
		isCurrentSort,
	}: {
		sortDirection: SortDirection;
		isCurrentSort?: boolean;
	}) => JSX.Element
> = memo(
	({
		sortDirection,
		isCurrentSort,
	}: {
		sortDirection: SortDirection;
		isCurrentSort?: boolean;
	}): JSX.Element => {
		const primaryColor = isCurrentSort ? token('color.icon.brand') : token('color.icon');

		const showSortUp = sortDirection === 'asc';
		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			<span css={styles} className={SortableIconClassName}>
				{showSortUp ? (
					<ArrowUpIcon label="" color={primaryColor} spacing="compact" size="small" />
				) : (
					<ArrowDownIcon label="" color={primaryColor} spacing="compact" size="small" />
				)}
			</span>
		);
	},
);
